import { useState } from "react";
import MyTable from "../../Components/MyTable";
import Mytitle from "../../Components/Mytitle";
import ModalForm from "../../Components/ModalForm";
import MyInput from "../../Components/Myinput";
import API from "../../Api/axiosConfig";
import { toast } from "react-toastify";
import MyButton from "../../Components/MyButton";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPen } from "@fortawesome/free-solid-svg-icons";
import Can from "../../Components/Can";
import { data } from "react-router-dom";

function Subscriptions() {
  const [showModal, setShowModal] = useState(false);
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    password: "",
    password_confirmation: "",
    from: "",
    to: "",
    value: "",
    is_trial: false,
    active: true,
  });
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [refreshKey, setRefreshKey] = useState(0);
  const [editId, setEditId] = useState(null);

  const handleAdd = () => {
    setFormData({
      name: "",
      email: "",
      password: "",
      password_confirmation: "",
      from: "",
      to: "",
      value: "",
      is_trial: false,
      active: true,
    });
    setEditId(null);
    setErrors({});
    setShowModal(true);
  };

  const handleEdit = (record) => {
    setFormData({
      from: record.from,
      to: record.to,
      value: record.value,
      is_trial: record.is_trial,
      active: record.active,
    });
    setEditId(record.uuid);
    setErrors({});
    setShowModal(true);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setErrors({});

    try {
      if (editId) {
        await API.put(`/subscriptions/${editId}`, formData);
        toast.success("تم تعديل الاشتراك بنجاح");
      } else {
        await API.post("/subscriptions", formData);
        toast.success("تم إضافة الاشتراك بنجاح");
      }
      setShowModal(false);
      setRefreshKey((prev) => prev + 1);
    } catch (err) {
      if (err.response?.data?.errors) {
        setErrors(err.response.data.errors);
      } else {
        toast.error("حدث خطأ غير متوقع");
      }
    } finally {
      setLoading(false);
    }
  };

  const columns = [
    { header: "من", accessor: "from" },
    { header: "إلى", accessor: "to" },
    { header: "القيمة", accessor: "value" },
    {
      header: "تجريبي؟",
      accessor: (row) => (row.is_trial ? "نعم" : "لا"),
    },
    {
      header: "مفعل؟",
      accessor: (row) => (row.active ? "نعم" : "لا"),
    },
    {
      header: "الايميل",
      accessor: (row) => row.store.user.email,
    },
    {
      header: "الإجراءات",
      accessor: (row) => (
        <Can permission="subscriber_update">
          <button
            className="btn btn-sm btn-primary mx-1 no-style"
            onClick={() => handleEdit(row)}>
            <FontAwesomeIcon icon={faPen} />
          </button>
        </Can>
      ),
      hideOnPrint: true,
    },
  ];

  return (
    <div className="container mt-5">
      <Mytitle title="الاشتراكات" />
      <Can permission="subscriber_create">
        <MyButton
          text="إضافة اشتراك"
          variant="success"
          type="button"
          className="mb-3"
          onClick={handleAdd}
        />
      </Can>

      <ModalForm
        show={showModal}
        onClose={() => setShowModal(false)}
        title={editId ? "تعديل الاشتراك" : "إضافة اشتراك"}
        onSubmit={handleSubmit}
        loading={loading}
        mode="form">
        {!editId && (
          <>
            <MyInput
              type="text"
              label="الاسم"
              value={formData.name}
              onChange={(e) =>
                setFormData({ ...formData, name: e.target.value })
              }
              error={errors.name?.[0]}
            />
            <MyInput
              type="email"
              label="البريد الإلكتروني"
              value={formData.email}
              onChange={(e) =>
                setFormData({ ...formData, email: e.target.value })
              }
              error={errors.email?.[0]}
            />
            <MyInput
              type="password"
              label="كلمة المرور"
              value={formData.password}
              onChange={(e) =>
                setFormData({ ...formData, password: e.target.value })
              }
              error={errors.password?.[0]}
            />
            <MyInput
              type="password"
              label="تأكيد كلمة المرور"
              value={formData.password_confirmation}
              onChange={(e) =>
                setFormData({
                  ...formData,
                  password_confirmation: e.target.value,
                })
              }
              error={errors.password_confirmation?.[0]}
            />
          </>
        )}

        <MyInput
          type="date"
          label="من"
          value={formData.from}
          onChange={(e) => setFormData({ ...formData, from: e.target.value })}
          error={errors.from?.[0]}
        />
        <MyInput
          type="date"
          label="إلى"
          value={formData.to}
          onChange={(e) => setFormData({ ...formData, to: e.target.value })}
          error={errors.to?.[0]}
        />
        <MyInput
          type="number"
          label="القيمة"
          value={formData.value}
          onChange={(e) => setFormData({ ...formData, value: e.target.value })}
          error={errors.value?.[0]}
        />
        <div className="form-check my-2">
          <input
            type="checkbox"
            className="form-check-input"
            checked={formData.is_trial}
            onChange={(e) =>
              setFormData({ ...formData, is_trial: e.target.checked })
            }
          />
          <label className="form-check-label">اشتراك تجريبي</label>
        </div>
        <div className="form-check my-2">
          <input
            type="checkbox"
            className="form-check-input"
            checked={formData.active}
            onChange={(e) =>
              setFormData({ ...formData, active: e.target.checked })
            }
          />
          <label className="form-check-label">مفعل</label>
        </div>
      </ModalForm>

      <MyTable
        resource="subscriptions"
        columns={columns}
        refreshKey={refreshKey}
      />
    </div>
  );
}

export default Subscriptions;
